export enum RouteKey {
    Home = "/",
    Workers = "/workers",
    Login = "/login",
    Onsite = "/onsite",
    Notifications = "/notifications",
    Map = "/map",
    ErrorPage = "*",
    Installer = "/installer/*",
    InstallerJob = "/installer/job/:jobId",
    InstallerJobBase = "/installer/job/",
    JobMedia = "/job/:jobId/media",
    MediaMigration = "/media-migration",
}

export const noSidebarRoutes = [RouteKey.Login, RouteKey.Installer, RouteKey.InstallerJob, RouteKey.InstallerJobBase];
